import {
	booleanAttribute,
	Component,
	computed,
	Input,
	OnInit,
	QueryList,
	ViewChildren,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Testquestion, TestquestionOption } from "@app/definitions/types"
import { flipYesNo, stripTags } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { NgTemplateOutlet } from "@angular/common"
import {
	BtnExtComponent,
	SpinOrContent,
	YesNo,
} from "@app/utils/utils.component"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"

@Component({
	selector: "app-testquestions-manage",
	imports: [
		COMMON_IMPORTS,
		NgTemplateOutlet,
		SpinOrContent,
		WysiwygComponent,
		LangValPipe,
		GenInputComponent,
		GenSelectComponent,
		YesNo,
		BtnExtComponent,
		ModalWrapComponent,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./testquestions-manage.component.html",
})
export class TestquestionsManageComponent extends Modalable {
	modalProps: any = null
	@Input() test_id: number = 0
	newTestquestion: Testquestion = new Testquestion()
	testquestions: Testquestion[] = []
	@Input() is_locked: string = "yes"
	@Input() is_public: string = "yes"
	@ViewChildren("firstField") firstField: QueryList<any>
	@ViewChildren("optValue") optValues: QueryList<any> //all fields that can receive focus, used to focus on them
	isNewSaving: boolean = false
	isCalculated = false
	isLtr: boolean = false

	async ngOnInit() {
		const res: any = await this.store.get_gen_items("testquestions")
		if (res?.testquestions) {
			this.testquestions = res.testquestions.filter(
				(row) => row.test_id == this.test_id
			)
			this.testquestions.forEach((row) => (row.errors = {}))
			this.prepRows()
		}
		this.createNewTestquestion()
		this.firstFieldFocusTO()
		const test = this.store.searchSiteDataItem(this.test_id, ["tests"])
		const origTest = test.test_id
			? this.store.searchSiteDataItem(test.test_id, ["tests"])
			: test

		this.isCalculated = origTest.calculated === "yes"
		this.is_locked = test.is_locked
		this.is_public = test.public
		this.isLtr = test.lang === "en"
	}

	async firstFieldFocusTO() {
		await this.store.timeout(100)
		this.focusfirstField()
	}

	focusfirstField() {
		if (!this.firstField?.length) {
			return
		}
		let element = this.firstField.first
		if (element) {
			element.focus()
		}
	}

	prepRows() {
		this.testquestions.sort(
			(a: Testquestion, b: Testquestion) => a.order_num - b.order_num
		)
		this.testquestions.forEach((row) => {
			row.optionsArr = []
			if (row.options) {
				row.optionsArr = JSON.parse(row.options)
				row.optionsArr.forEach((opt, pos) => (opt.order_num = pos + 1))
			}
			this.sortRowOptionsArr(row)
			row.is_highest_order = false
			row.is_lowest_order = false
		})
		if (this.testquestions.length) {
			this.testquestions[0].is_lowest_order = true
			this.testquestions[this.testquestions.length - 1].is_highest_order = true
		}
	}

	async moveOrderNum(row: Testquestion, toLowerOrderNum: boolean) {
		// const orderNumToSearch=row.order_num+(toLowerOrderNum?-1:1);
		const rowToFlip = this.store.findClosestOrderNum(
			this.testquestions,
			row.order_num,
			toLowerOrderNum
		)
		if (rowToFlip) {
			const flipOrderNum = rowToFlip.order_num
			row.isFlipOrderSending = true
			const res = await this.apiService.post("flip_order_num", {
				id1: row.id,
				id2: rowToFlip.id,
				tableName: "testquestions",
			})
			row.isFlipOrderSending = false
			if (res.success) {
				this.modalService.openToast("update_successfuly")
				rowToFlip.order_num = row.order_num
				row.order_num = flipOrderNum
				this.store.updGenItemRowField(
					"testquestions",
					row.id,
					"order_num",
					row.order_num
				)
				this.store.updGenItemRowField(
					"testquestions",
					rowToFlip.id,
					"order_num",
					rowToFlip.order_num
				)
				this.prepRows()
			} else {
				this.modalService.openToast("save_failed")
			}
		}
	}

	validateField(row: Testquestion, fieldName: string) {
		// row.errors={};
		// const isEditSubmittable=this.validator.validateEntireForm(row, row.errors, this.validationRules,this.tests);
		// if(isEditSubmittable){
		//   this.editFieldTest(row,fieldName);
		// }
	}

	updateRowFieldsPreSave(row: Testquestion) {
		const makeNullIfEmpty = ["mark", "range_min", "range_max"]
		makeNullIfEmpty.forEach((field) => {
			if (!row[field]) {
				row[field] = null
			}
		})

		if (row.correct_answer !== 0 && !row.correct_answer) {
			row.correct_answer = null
		}

		if (row.field_type != "number") {
			// row.mark = null
			row.correct_answer = null
			row.range_min = null
			row.range_max = null
		}

		if (["text", "number"].includes(row.field_type)) {
			row.optionsArr = []
			row.options = ""
			row.question_num = 0
		} else {
			//options
			row.options = JSON.stringify(
				row.optionsArr.map((it) => ({ value: it.value, mark: it.mark }))
			)
		}
	}
	validateEntireForm(row: Testquestion, isKeyup: boolean = false) {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.updateRowFieldsPreSave(row)
		row.errors = {}

		const validationRules: any = {
			question: { not_empty: true },
		}
		if (Number(row.question_num)) {
			validationRules.question_num = { unique: true }
		}
		if (row.field_type == "remark") {
			row.required = "no"
		}
		if (row.field_type == "number") {
			if (row.correct_answer !== null) {
				validationRules.correct_answer = { is_integer: true }
			}

			if (row.range_min || row.range_max) {
				validationRules.range_min = { not_null: true, is_integer: true }
				validationRules.range_max = { not_null: true, is_integer: true }
				if (row.range_min && row.range_max) {
					validationRules.range_max.larger_than = row.range_min
					if (row.correct_answer !== null) {
						validationRules.correct_answer.larger_than =
							Number(row.range_min) - 1
						validationRules.correct_answer.smaller_than =
							Number(row.range_max) + 1
					}
				}
			}
		}

		row.isFormSubmittable = this.validator.validateEntireForm(
			row,
			row.errors,
			validationRules,
			this.testquestions
		)

		if (["text", "number", "remark"].includes(row.field_type)) {
			//
		} else {
			//options
			if (row.optionsArr.length < 2) {
				row.isFormSubmittable = false
				row.errors.options = this.lang.getVal("at_least_2")
			} else {
				for (let opt of row.optionsArr) {
					if (!opt.value.trim()) {
						row.isFormSubmittable = false
						row.errors.options = this.validator.replaceFieldName(
							"options",
							this.lang.getVal("is_empty")
						)
						break
					}
				}

				if (!row?.errors?.options) {
					if (this.isCalculated && Number(row.question_num)) {
						const optWithSameMark = row.optionsArr.find((opt) =>
							row.optionsArr.find(
								(otherOpt) => opt !== otherOpt && opt.mark == otherOpt.mark
							)
						)
						if (optWithSameMark) {
							row.isFormSubmittable = false
							row.errors.options = this.lang.getVal("not_same_values")
						}
					}
				}
			}
			// if(row.optionsArr.length){
			//   validationRules.correct_answer.larger_than=0;
			//   validationRules.correct_answer.smaller_than=row.optionsArr.length+1;
			// }
			// validationRules.correct_answer
		}

		if (row.isFormSubmittable && row.id && !isKeyup) {
			this.updateTestquestion(row)
		}
	}
	async updateTestquestion(row: Testquestion) {
		const res = await this.apiService.post("update_test_question", row)
		this.modalService.openToast("update_successfuly")
		this.store.siteDataUpdateRow("testquestions", row)
	}

	async saveNewTestquestion() {
		if (!this.newTestquestion.isFormSubmittable) {
			return
		}
		const sendObj = { ...this.newTestquestion }
		delete sendObj.errors
		this.isNewSaving = true
		const res: any = await this.apiService.save_gen_item(
			"testquestions",
			sendObj
		)
		this.isNewSaving = false
		if (res?.id) {
			res.errors = {}
			this.store.addGenItemRow("testquestions", res)
			this.testquestions = [...this.testquestions, res]
			this.prepRows()
			this.createNewTestquestion()
			this.modalService.openToast("saved_successfully")
			this.firstFieldFocusTO()
		} else {
			this.modalService.openToast("save_failed")
		}
	}

	createNewTestquestion() {
		this.newTestquestion = new Testquestion()
		this.newTestquestion.test_id = this.test_id
		if (this.testquestions.length) {
			const lastQues = this.testquestions[this.testquestions.length - 1]

			;[
				"field_type",
				"correct_answer",
				"mark",
				"range_min",
				"range_max",
			].forEach((field) => {
				this.newTestquestion[field] = lastQues[field]
			})
			this.newTestquestion.optionsArr = lastQues?.optionsArr?.length
				? [...lastQues.optionsArr.map((it) => ({ ...it }))]
				: []
		}
	}

	// async editFieldTest(test:Test,fieldName:string){
	//   const res:any=await this.apiService.save_gen_field("tests",test.id,fieldName,test[fieldName]);
	// if(res?.success){
	//   this.store.updGenItemRowField("tests",test.id,fieldName,test[fieldName]);
	// }
	// }
	async handleDeleteApprove(approved: boolean) {
		const { row } = this.modalProps
		this.modalProps = null
		if (!approved) {
			return
		}

		row.isDeleting = true
		const res: any = await this.apiService.delete_gen_item(
			"testquestions",
			row.id
		)
		row.isDeleting = false
		if (res.success) {
			this.modalService.openToast("delete_successful")
			this.store.delGenItemRow("testquestions", row.id)
			this.testquestions = this.testquestions.filter((it) => it.id != row.id)
			this.prepRows()
		} else {
			this.modalService.openToast("delete_failed")
		}
	}
	deleteTestquestion(row: Testquestion) {
		this.modalProps = {
			name: "confirm-delete",
			row,
			objectName: stripTags(row.question),
		}
	}

	sortRowOptionsArr(row: Testquestion) {
		row.optionsArr.sort(
			(a: TestquestionOption, b: TestquestionOption) =>
				a.order_num - b.order_num
		)
		row.optionsArr.forEach((opt) => (opt.is_highest_order = false))
		if (row.optionsArr?.length) {
			row.optionsArr[row.optionsArr.length - 1].is_highest_order = true
		}
	}

	removeOpt(row: Testquestion, opt: TestquestionOption) {
		row.optionsArr = row.optionsArr.filter(
			(optItem) => optItem.order_num != opt.order_num
		)
		let pos = 1
		for (let opt of row.optionsArr) {
			opt.order_num = pos
			pos++
		}
		this.sortRowOptionsArr(row)
		this.validateEntireForm(row)
	}
	async addOpt(row: Testquestion) {
		const order_num = this.getOptionsArrTopOrderNum(row) + 1
		row.optionsArr = [...row.optionsArr, { order_num, value: "", mark: 0 }]
		this.sortRowOptionsArr(row)
		this.validateEntireForm(row)

		const dataRowField = (row?.id || 0) + "_" + order_num
		if (!this.optValues) {
			return
		}
		await this.store.timeout(100)
		const el = this.optValues.find(
			(component) => component.dataRowField == dataRowField
		)
		if (el) {
			el.focus()
		}
	}
	getOptionsArrTopOrderNum(row: Testquestion) {
		return row.optionsArr.reduce((acc, row) => Math.max(acc, row.order_num), 0)
	}
	moveOptOrderNum(
		row: Testquestion,
		opt: TestquestionOption,
		toLowerOrderNum: boolean
	) {
		const orderNumToSearch = opt.order_num + (toLowerOrderNum ? -1 : 1)
		const optToFlip = row.optionsArr.find(
			(t) => t.order_num == orderNumToSearch
		)

		if (optToFlip) {
			optToFlip.order_num = opt.order_num
			opt.order_num = orderNumToSearch
		}
		this.sortRowOptionsArr(row)
		this.validateEntireForm(row)
	}
	handleRequiredChange(row) {
		row.required = flipYesNo(row.required)
		this.validateEntireForm(row)
	}
}
